/**
 * Mensagens de campo obrigatório e de tipo inválido no formato do zod 4 (o zod 3 tinha `required_error` e
 * `invalid_type_error`). Campo ausente (undefined) recebe `requiredMessage`; outro problema de tipo recebe
 * `invalidTypeMessage` ou, sem ele, a mensagem padrão do zod.
 */
export function required(requiredMessage: string, invalidTypeMessage?: string) {
    return {
        error: (issue: { input?: unknown }) => (issue.input === undefined ? requiredMessage : invalidTypeMessage),
    }
}
